import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    motivoResultado: [],
  },

  getters: {
    getMotivoResultado: (state) => state.motivoResultado,
  },

  mutations: {
    SET_MOTIVO_RESULTADO(state, motivoResultado) {
      state.motivoResultado = motivoResultado;
    },
  },

  actions: {
    async fetchMotivoResultado({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catmotivoResultado')
        .then((response) => {
          commit('SET_MOTIVO_RESULTADO', response.data.data);
        });
    },
  },
};
